import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop reordering of quiz questions in the builder.
// On drop, calls the reposition endpoint with the new position.
export default class extends Controller {
  static values = {
    repositionUrlTemplate: String
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-quiz--builder-target='handle']",
      animation: 150,
      onEnd: (event) => this.handleDrop(event)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async handleDrop(event) {
    const item = event.item
    const questionId = item.dataset.quizQuestionId
    const newPosition = event.newIndex + 1

    const url = this.repositionUrlTemplateValue.replace(":id", questionId)

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ position: newPosition })
      })

      if (!response.ok) {
        throw new Error(`Reposition failed with status ${response.status}`)
      }
    } catch (error) {
      console.error("Quiz question reposition failed:", error)
      window.location.reload()
    }
  }
}
